import { render, staticRenderFns } from "./certificatechildren.vue?vue&type=template&id=406ce1fa"
import script from "./certificatechildren.vue?vue&type=script&lang=js"
export * from "./certificatechildren.vue?vue&type=script&lang=js"
import style0 from "./certificatechildren.vue?vue&type=style&index=0&id=406ce1fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports